import colors from '../_shared/colors';

export default {
  container: `
    display: flex;
    flex: 1;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: ${colors.white};
    overflow: auto;
  `,
  title: `
    color: ${colors.highlight};
    font-size: 12px;
    font-weight: bold;
    text-align: center;
  `,
  subTitle: `
    font-size: 12px;
  `,
  error: `
    color: ${colors.error};
    font-size: 14px;
    text-align: center;
    max-width: 300px;
  `,
  inputContainer: `
    margin-top: 10px;
    width: 90%;
    max-width: 400px;
    border: 1px solid ${colors.inputBorder};
    padding: 20px;
  `,
  fgPassword: `
    position: absolute;
    top: -30px;
    right: 0px;
    color: ${colors.labelColor};
    font-size: 10px;
    float: right;
    cursor: pointer;
  `,
  buttonContainer: `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0;
    martin-top: -10px;
  `,
  passwordPrompt: `
    text-align: justify;
  `,
  brandedLoginForm: `
    padding-top: 20px;
    width: 80%;
    max-width: 300px;
  `,
  column: `
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  // AER-1755: the "First time registering equipment? ..." prompt on the
  // Equipment Registration login screen. It used to sit hard against the
  // Sign In button; the design drops it well clear of the button.
  signUpPrompt: `
    margin-top: 35px;
    text-align: center;
  `,
  // AER-1755: "Sign Up" reads as a bolded purple link instead of the old
  // rectangular button. It is a real <button> stripped of its native chrome
  // rather than a <span>, so keyboard users keep the focusability and
  // Enter/Space activation the removed <Button> gave them and assistive tech
  // still announces a button. It flips `showSignup` state, it does not
  // navigate, so a <button> — not an <a> — is the correct element.
  signUpLink: `
    display: inline;
    appearance: none;
    -webkit-appearance: none;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    font: inherit;
    font-weight: bold;
    vertical-align: baseline;
    text-align: inherit;
    color: ${colors.highlight};
    cursor: pointer;
    &:hover,
    &:focus {
      color: ${colors.highlight};
      text-decoration: underline;
    }
    /* Visible focus ring. The purple reads clearly against the white card.
       Legacy browsers get the ring on any focus; browsers that support
       :focus-visible get it for keyboard focus only. */
    &:focus {
      outline: 2px solid ${colors.highlight};
      outline-offset: 2px;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
    &:focus-visible {
      outline: 2px solid ${colors.highlight};
      outline-offset: 2px;
    }
  `
};
